import { A, pipe } from "@mobily/ts-belt";
import PropTypes from "prop-types";
import * as React from "react";
import useSWR from "swr";
import { fetcher } from "../../../hooks";
import { Spinner, Typography } from "../../../themeV2";
import CategoryTree from "../../ShopCategories/CategoryTree";
import styles from "./ShopSettingsDialog.module.css";

export default function CategoriesContent({ influencerId }) {
  const { data: associatedData, mutate } = useSWR(
    `/api/categories/influencer/${influencerId}`,
    fetcher,
  );
  const { data: allCategories } = useSWR(`/api/categories?all=true`, fetcher);

  const associatedIds = React.useMemo(
    () =>
      pipe(
        associatedData?.categories ?? [],
        A.map((c) => c.category_id),
      ),
    [associatedData?.categories],
  );

  const handleToggle = React.useCallback(
    async (categoryIds) => {
      try {
        const res = await fetch(`/api/categories/influencer/${influencerId}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ categoryIds }),
        });

        if (!res.ok) {
          throw new Error("Failed to update categories");
        }

        mutate();
      } catch (err) {
        console.error(err);
      }
    },
    [influencerId, mutate],
  );

  return (
    <div>
      <Typography
        variant="body-lg"
        color="variant"
        as="p"
        className={styles.categoryDescription}
      >
        Set the categories for the shop. This helps users discover talent
        through search and browse features.
      </Typography>

      {!allCategories || !associatedData ? (
        <div className={styles.spinnerCenter}>
          <Spinner />
        </div>
      ) : (
        <CategoryTree
          nodes={allCategories.categories}
          onToggle={handleToggle}
          selected={associatedIds}
          mutate={mutate}
        />
      )}
    </div>
  );
}

CategoriesContent.propTypes = {
  influencerId: PropTypes.number.isRequired,
};
